import React, { ReactElement } from "react";
import classnames from "classnames";
import { FormattedMessage } from "react-intl";

import { ModalDialog } from "../Modal";
import { useScreenSizeSpecChange } from "../../../common/Responsive";

import "./MobileModal.scss";

interface MobileModalProps {
  modal: any;
  header: ReactElement | string;
  content: ReactElement;
  footer?: ReactElement;
  className?: string;
}

export const MobileModal = ({
  modal,
  header,
  content,
  footer,
  className = "",
}: MobileModalProps) => {
  const { resolve, reject } = modal;

  useScreenSizeSpecChange(reject);

  return (
    <ModalDialog
      className={classnames("mobile-modal", className)}
      submitHandler={resolve}
      rejectHandler={reject}
    >
      <ModalDialog.Header>{header}</ModalDialog.Header>
      <ModalDialog.Body>{content}</ModalDialog.Body>
      <ModalDialog.Footer>
        <ModalDialog.Control>
          <button type="button" onClick={reject}>
            {footer ? footer : <FormattedMessage id={"dismiss"} />}
          </button>
        </ModalDialog.Control>
      </ModalDialog.Footer>
    </ModalDialog>
  );
};
